import config from 'config'
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import axiosRetry from 'axios-retry'
import { Logger } from '@vp/ubik-logging'
import { applyServiceHeaders } from 'server/utils/applyServiceHeaders'

export type LoggerParameter = (() => Gallery.Logger.ILogger) | Gallery.Logger.ILogger

// Creating this type here since we can't import in definition files
export type AbstractServiceConfig = Gallery.Config.IServiceConfig & AxiosRequestConfig

const GLOBAL_CONFIG = config.services.global

export class AbstractService {
  api: AxiosInstance

  config: AbstractServiceConfig

  loggerOrProvider: LoggerParameter

  constructor(serviceConfig: AbstractServiceConfig, logger: LoggerParameter) {
    this.api = axios.create(
      applyServiceHeaders({
        ...serviceConfig,
      }),
    )

    this.config = serviceConfig || {}
    this.loggerOrProvider = logger
    this.attachRetryHandler(this.api)
  }

  get logger(): Logger {
    return typeof this.loggerOrProvider === 'function' ? this.loggerOrProvider() : this.loggerOrProvider
  }

  attachRetryHandler(instance: AxiosInstance): void {
    const retries = this.config.retry?.retries || GLOBAL_CONFIG.retry?.retries || 3

    axiosRetry(instance, {
      retries,
      retryDelay: (retryCount) => axiosRetry.exponentialDelay(retryCount),
    })
  }
}
